<template>
  <!--帖子详情-->
  <tk-container
    :status="status"
    @refresh="refreshInit"
  >
    <!--帖子头部-->
    <my-header slot="header"></my-header>
    <!--帖子详情-->
    <div
      class="posts-detail"
      v-if="postsDetail"
      :class="{'p-b-32':(postsDetail.userFans.length || postsDetail.reviewsPostsList.length)}"
    >
      <!--头像与关注-->
      <tk-flex between class="p-x-12 p-t-10">
        <tk-flex middle @click.native="$push({path: '/itsMine/postsProfile', query: {id: postsDetail.author.objectId}})">
          <tk-avatar size="30">
            <tk-image :src="avatarSrc" height="30" width="30"></tk-image>
          </tk-avatar>
          <tk-flex
            column
            class="m-l-10"
          >
            <div class="font-bold">{{postsDetail.author && postsDetail.author.name ? postsDetail.author.name : '用户'}}</div>
          </tk-flex>
        </tk-flex>
        <div>
          <div class="post-card-watch" v-if="!postsDetail.isWatch" @click.stop="watchAuthor">关注</div>
          <div class="post-card-watch" v-else @click.stop="watchAuthor">已关注</div>
        </div>
      </tk-flex>
      <!--内容-->
      <div
        class="font-15 p-x-12 p-y-10 copy-text text-area-pre"
        v-html="postsDetail.content"></div>
      <!--图片-->
      <div v-if="postsDetail.pictureCombination" class="p-x-15">
        <tk-flex
          column
          v-for="(s, index) in postsDetail.pictureCombination"
          @click.native="viewHtmlImages(index)"
          :key="index"
        >
          <div class="welfare-link-image" :class="{ 'm-t-15': index > 0 }">
            <van-image lazy-load style="height: 100%;" width="100%" :src="s"></van-image>
          </div>
        </tk-flex>
      </div>
      <!--点赞评论提示-->
      <tk-flex
        middle
        between
        class="p-12"
        style="color: #999;"
      >
        <div class="caption font-bold m-t&#45;&#45;5">{{postsDetail.createdAt | datetime}}</div>
        <tk-flex class="font-13">
          <div class="m-r-20" @click="likesPosts()">
            <tk-icon v-if="!judgeUserFans(userInfo.objectId)" size="20" color="#666" class="m-r-5 m-b-4">favorite</tk-icon>
            <tk-icon v-else size="20" color="#FA3333" class="m-r-5 m-b-4">collected</tk-icon>
            赞
          </div>
          <div @click="changeCommentsStatus()">
            <tk-icon size="20" color="#666" class="m-r-5 m-b-4">comment</tk-icon>
            评论
          </div>
        </tk-flex>
      </tk-flex>
      <!--点赞及评论详情-->
      <div
        class="posts-card-footer p-x-12 p-y-5"
        v-if="postsDetail.userFans.length || postsDetail.reviewsPostsList.length"
      >
        <!--点赞-->
        <tk-flex
          wrap
          middle
          :gutter="5"
          class="posts-card-footer-top"
          v-if="postsDetail.userFans.length"
        >
          <tk-icon size="18" color="rgba(91, 108, 143, 1)">favorite</tk-icon>
          <tk-flex
            middle
            v-for="(s, index) in postsDetail.userFans"
            :key="`posts-card-footer-top${index}`"
          >
            <tk-avatar size="28">
              <tk-image :replacement="false" :src="s.avatar ? s.avatar : defaultImage" width="28" height="28"></tk-image>
            </tk-avatar>
          </tk-flex>
        </tk-flex>
        <!--评论-->
        <tk-flex
          class="posts-card-footer-bottom m-t-4"
          v-if="postsDetail.reviewsPostsList.length"
        >
          <tk-icon size="20" color="#999" class="m-r-5 m-t-2">comment</tk-icon>
          <div style="width: 100%;">
            <div
              style="width: 100%;"
              v-for="(item, firstIndex) in postsDetail.reviewsPostsList"
              :key="`posts-card-footer-bottom${firstIndex}`"
            >
              <tk-flex class="fill font-12">
                <tk-avatar size="28">
                  <tk-image :replacement="false" :src="item.reviewer.avatar ? item.reviewer.avatar : defaultImage" width="28" height="28"></tk-image>
                </tk-avatar>
                <tk-flex column middle
                         class="full-width full m-l-5"
                >
                  <tk-flex
                    column
                    class="full-width"
                    @touchstart.native="gtouchstart($event, item.reviewer, item, firstIndex)"
                    @touchmove.native="gtouchmove()"
                    @touchend.native="gtouchend(item.reviewer, item, firstIndex)"
                  >
                    <div
                      class="posts-card-footer-bottom-color full-width"
                    >
                      <span class="font-bold">{{item.reviewer.name ? item.reviewer.name : '用户'}}</span>
                    </div>
                    <div
                      class="posts-card-footer-bottom-color"
                      v-if="item.reviewer"
                    >
                      <span style="color: #000000;">{{item.reviewerContent ? item.reviewerContent : '无评论信息'}}</span>
                    </div>
                  </tk-flex>
                  <!--回复数据-->
                  <div
                    v-if="item.whatToReply && item.whatToReply.length"
                    class="full-width"
                  >
                    <tk-flex
                      middle
                      between
                      class="p-t-2 full-width"
                      v-for="(m, index) in item.whatToReply"
                      :key="`whatToReply${index}`"
                    >
                      <div
                        class="posts-card-footer-bottom-color font-bold"
                      >
                        <span @click="enterReplytoe(m.replytoe, item, firstIndex)">{{m.replytoe.name}}</span>
                        <span class="m-x-5" style="font-weight: normal;color: #000000;">回复</span>
                        <span  @click="enterReplytoe(m.recipient, item, firstIndex)">{{m.recipient.name + '：'}}</span>
                        <span style="font-weight: normal;color: #000000;">{{m.content}}</span>
                      </div>
                      <div
                        v-if="m.replytoe.objectId === userInfo.objectId"
                        class="delete-replytoe"
                        :style="{ background: isDelReplytoe ? 'rgba(0, 0, 0, 0.2)' : 'rgba(255, 255, 255, 0)' }"
                        @click="deleteReplyToe(m.replytoe, firstIndex, index)"
                      >
                        <tk-icon :size="14" :color="isDelReplytoe ? '#eaeaea' : '#999'">lajixiang</tk-icon>
                      </div>
                    </tk-flex>
                  </div>
                </tk-flex>
              </tk-flex>
            </div>
          </div>
        </tk-flex>
      </div>
    </div>
    <!--输入框-->
    <div
      slot="footer"
      class="comments"
      v-show="isCommentsShow"
    >
      <tk-flex bottom center class="fill">
        <div class="comments-bg">
          <tk-flex middle class="full-width">
            <textarea-autosize
              ref="textarea"
              :placeholder="placeholder"
              @blur.native.prevent="getBlur()"
              v-focus
              style="padding-left: 8px;"
              class="comments-area fill p-y-5 p-r-4"
              name="opinion"
              id="postsTextarea"
              cols="40" rows="1"
              v-model="comments"
              :min-height="32"
              :max-height="350"
            >
            </textarea-autosize>
          </tk-flex>
        </div>
        <div class="comments-btn p-t-2 text-right">
          <tkui-button @click="enterComments" :disabled="!comments" class="comments-btn-enter primary small raised">发送</tkui-button>
        </div>
      </tk-flex>
    </div>
    <!--删除评论弹框-->
    <tk-cover
      :show.sync="isShowTouch"
      :color="'rgba(255, 255, 255, 0)'"
      transition
    >
      <tk-flex
        middle
        column
        class="posts-detail-delete"
        :style="{ left: clientLeft - 32 + 'px', top: clientTop - 118 + 'px' }"
      >
        <div class="font-14 text-gray" @click="copyReviews()">复制</div>
        <div style="margin-top: 35px;" class="text-gray font-14" @click="deleteSelfReplytoe()">删除</div>
      </tk-flex>
    </tk-cover>
    <!--查看大图组件-->
    <view-big-image
      ref="postsDetail"
      :watch-num="watchNum"
      v-if="postsDetail && postsDetail.pictureCombination"
      :commodity-image="postsDetail.pictureCombination"
    ></view-big-image>
  </tk-container>
</template>

<script>
import { judgePosts } from '@/assets/help/posts'
import viewBigImage from '@/components/viewBigImage'
import { Image as VanImage } from 'vant'
const copy = require('clipboard-copy')
export default {
  components: {
    viewBigImage,
    [VanImage.name]: VanImage
  },
  data () {
    return {
      status: 'loading',
      enterLoading: false,
      deleteRender: {
        recipient: {},
        data: {},
        index: 0
      },
      watchNum: 0, // 查看大图的起始缩影
      isShowTouch: false, // 长按后的的弹框
      isDelReplytoe: false, // 删除回复状态
      timeOutEvent: 0, // 长按延时器定义
      clientTop: 0, // 弹框位置
      clientLeft: 0, // 弹框位置
      imageInstance: null, // 图片预览实例
      postsDetail: null, // 指定帖子详情数据
      isCommentsShow: true, // 输入框显示状态
      praiseDisable: false, // 点赞状态
      placeholder: '评论', // 输入框提示
      recipient: null, // 接收人信息
      reviewsIndex: 0, // 回复人的索引
      reviewsData: null, // 回复人信息
      comments: '' // 评论内容
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        // el.focus()
      },
      componentUpdated: function (el) {
        // el.focus()
      }
    }
  },
  computed: {
    // 帖子作者的头像
    avatarSrc () {
      if (!this.postsDetail) { return this.defaultImage }
      if (!this.postsDetail.author) { return this.defaultImage }
      if (!this.postsDetail.author.avatar) { return this.defaultImage }
      return this.postsDetail.author.avatar
    },
    authorId () {
      if (!this.postsDetail) { return '' }
      if (!this.postsDetail.author) { return '' }
      return this.postsDetail.author.objectId
    }
  },
  mounted () {
    this.getInit()
  },
  beforeRouteLeave (to, from, next) {
    this.$setFlash('updatePosts', this.postsDetail)
    if (this.imageInstance) { this.imageInstance.close() }
    this.clearSelector()
    next(true)
  },
  methods: {
    /**
     * 初始化数据
     * @date: 2020/3/26
     */
    async getInit () {
      try {
        this.setStatusBar('dark')
        await this.getPostsDetail() // 获取帖子详情
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * 清除选中
     * @date: 2020/8/28
     */
    clearSelector () {
      if (window.getSelection()) {
        const selection = window.getSelection()
        selection.removeAllRanges()
      } else if (document.selection && document.selection.empty) {
        document.selection.empty()
        // document.selection.clear()
      }
    },
    /**
    * 数据错误重新加载触发
    * @date: 2020/3/26
    */
    async refreshInit () {
      await this.getInit()
    },
    /**
    * 根据用户id跳到个人主页
    * @id: user.objectId
    * @date: 2020/3/26
    */
    async specifiedPage (id) {
      if (!id) { return this.$tkGlobal.toast.add('未找到该用户主页信息') }
      let judgeUser = await this.judgeId(id, '_User')
      if (!judgeUser) { return this.$tkGlobal.toast.add('未找到该用户主页信息') }
      // this.$push({ path: '/local/informationProfile', query: { id: id } })
    },
    /**
     * 查看大图
     * @date: 2020/5/25
     */
    viewHtmlImages (num) {
      this.watchNum = num
      this.$refs.postsDetail.showImages()
    },
    /**
     * 判断是否关注了作者
     * @date: 2020/3/30
     */
    async getPostsWatch (authorId) {
      let res = await this.$tkParse.getList(`/classes/watchPostUser`, {
        params: {
          limit: 1,
          where: {
            author: authorId,
            userFans: this.userInfo.objectId
          }
        }
      })
      return !!res.length
    },
    /**
    * 获取指定帖子详情
    * @date: 2020/3/26
    */
    async getPostsDetail () {
      let postsDetail = await this.$tkParse.getList(`/classes/InformationPosts`, { params: { limit: 1, include: 'author', where: { objectId: this.$route.query.id } } })
      if (postsDetail.length) {
        this.postsDetail = postsDetail[0]
        if (!this.postsDetail.userFans) { this.postsDetail.userFans = [] }
        if (!this.postsDetail.reviewsPostsList) { this.postsDetail.reviewsPostsList = [] }
        if (this.postsDetail.author) { this.postsDetail.isWatch = await this.getPostsWatch(this.postsDetail.author.objectId) }
        this.$forceUpdate()
      } else { this.postsDetail = null }
    },
    /**
     * 获取语意化时间渲染
     * @date: 2020/3/26
     */
    getFromNow (date) {
      return this.$tkDate(date).fromNow()
    },
    /**
     * 判断点赞数组
     * @date: 2020/3/30
     */
    judgeUserFans (id) {
      let index = this.postsDetail.userFans.findIndex(s => { return s.objectId === id })
      return index !== -1
    },
    /**
     * 切换输入框的显示
     * @date: 2020/3/30
     */
    changeCommentsStatus () {
      this.isCommentsShow = !this.isCommentsShow
    },
    /**
    /**
     * 点赞帖子
     * @date: 2020/3/26
     */
    async likesPosts () {
      if (!this.postsDetail) { return this.$tkGlobal.toast.add('此贴子可能已删除') }
      if (!await this.judgeId(this.postsDetail.objectId, 'InformationPosts')) {
        return this.$tkGlobal.toast.add('此贴子可能已删除')
      }
      if (this.praiseDisable) { return this.$tkGlobal.toast.add('您点的太快了') }
      this.praiseDisable = true
      // 数据
      if (!this.postsDetail.userFans) { this.postsDetail.userFan = [] }
      if (!this.postsDetail.likeUser) { this.postsDetail.likeUser = [] }
      if (!this.judgeUserFans(this.userInfo.objectId)) { // 点赞
        this.postsDetail.userFans.push({
          objectId: this.userInfo.objectId,
          date: new Date().toISOString(),
          name: this.userInfo.name ? this.userInfo.name : '用户',
          phone: this.userInfo.phone,
          avatar: this.userInfo.avatar ? this.userInfo.avatar : this.defaultImage
        })
        this.postsDetail.likeUser.push(this.userInfo.objectId)
        await this.$tkParse.put(`/classes/InformationPosts/${this.postsDetail.objectId}`,
          { userFans: this.postsDetail.userFans, likeUser: this.postsDetail.likeUser })
        await this.$tkParse.post('/classes/praisePosts', {
          InformationPosts: this.postsDetail.objectId,
          praiseUser: this.postsDetail.author.objectId,
          userFans: this.userInfo.objectId
        })
        this.$tkGlobal.toast.add('点赞成功')
        setTimeout(() => { this.praiseDisable = false }, 500)
        this.$forceUpdate()
        return
      }
      // 取消赞
      if (this.postsDetail.userFans.length) {
        let findIndex = this.postsDetail.userFans.findIndex(s => { return s.objectId === this.userInfo.objectId })
        this.postsDetail.userFans.splice(findIndex, 1)
      }
      if (this.postsDetail.likeUser.length) {
        let likeIndex = this.postsDetail.likeUser.findIndex(s => { return s === this.userInfo.objectId })
        this.postsDetail.likeUser.splice(likeIndex, 1)
      }
      await this.$tkParse.put(`/classes/InformationPosts/${this.postsDetail.objectId}`,
        { userFans: this.postsDetail.userFans,
          likeUser: this.postsDetail.likeUser })
      let res = await this.$tkParse.getList('/classes/praisePosts', {
        params: {
          limit: 1,
          where: {
            praiseUser: this.postsDetail.author.objectId,
            userFans: this.userInfo.objectId,
            InformationPosts: this.postsDetail.objectId
          }
        }
      })
      if (res.length) {
        await this.$tkParse.delete(`/classes/praisePosts/${res[0].objectId}`)
      }
      this.$tkGlobal.toast.add('取消成功')
      setTimeout(() => { this.praiseDisable = false }, 500)
      this.$forceUpdate()
    },
    /**
     * 关注作者
     * @date: 2020/3/25
     */
    async watchAuthor () {
      if (!this.postsDetail || !this.postsDetail.author) { return this.$tkGlobal.toast.add('未找到您要关注的用户') }
      if (this.watchDisabled) { return }
      if (this.userInfo.objectId === this.postsDetail.author.objectId) { return this.$tkGlobal.toast.add('不能关注自己哦') }
      this.status = 'waiting'
      this.watchDisabled = true
      // 数据
      let obj = {
        author: this.postsDetail.author.objectId,
        userFans: this.userInfo.objectId
      }
      let watchStatus = await judgePosts('watchPostUser', { userFans: this.userInfo.objectId, author: this.postsDetail.author.objectId })
      // 判断关注作者
      if (this.postsDetail.isWatch && watchStatus) {
        // 取消关注
        this.$tkGlobal.toast.add('您已经关注了该作者')
        this.postsDetail.isWatch = true
        await this.$tkHelper.sleep(500)
        this.watchDisabled = false
      } else { // 给关注列表添加数据
        this.postsDetail.isWatch = true
        await this.$tkParse.post(`/classes/watchPostUser`, obj)
        this.$tkGlobal.toast.add('关注成功')
      }
      this.$setFlash('watchProfile', this.postsDetail)
      this.$forceUpdate()
      setTimeout(e => {
        this.watchDisabled = false
        this.status = false
      }, 500)
    },
    /**
     * 失去焦点
     * @date: 2020/3/26
     */
    getBlur () {
      setTimeout(() => {
        this.isCommentsShow = true
      }, 100)
    },
    /**
    * 长按操作
    * @date: 2020/8/21
    */
    gtouchstart (e, recipient, data, index) {
      this.timeOutEvent = setTimeout(() => {
        this.longPress(e, recipient, data, index)
      }, 100)
      return false
    },
    /**
     * 手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
     * @date: 2020/8/21
     */
    gtouchend (recipient, data, index) {
      clearTimeout(this.timeOutEvent)// 清除定时器
      if (this.timeOutEvent !== 0) {
        // 这里写要执行的内容（尤如onclick事件）
        // alert('你这是点击，不是长按')
        // recipient 接收人 replytoe 回复人
        if (!recipient) { return this.$tkGlobal.toast.add('未找到您要回复用户的信息') }
        if (recipient.objectId === this.userInfo.objectId) { return this.$tkGlobal.toast.add('您不能回复自己哦') }
        this.isCommentsShow = true
        this.reviewsData = data // 获取评论的信息
        this.recipient = recipient // 获取接收人信息
        this.reviewsIndex = index
        this.placeholder = `回复${recipient.name}：` // 改变placeholder
        this.$forceUpdate()
      }
      return false
    },
    /**
    * 如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
    * @date: 2020/8/21
    */
    gtouchmove () {
      clearTimeout(this.timeOutEvent) // 清除定时器
      this.timeOutEvent = 0
    },
    /**
    * 真正长按后应该执行的内容
    * @date: 2020/8/21
    */
    longPress (e, recipient, data, index) {
      if (recipient.objectId !== this.userInfo.objectId &&
        this.postsDetail.author.objectId !== this.userInfo.objectId) {
        return
      }
      this.deleteRender = {
        recipient: {},
        data: {},
        index: 0
      }
      this.timeOutEvent = 0
      // 执行长按要执行的内容，如弹出菜单
      this.deleteRender = {
        recipient: recipient,
        data: data,
        index: index
      }
      this.clientTop = e.changedTouches['0'].clientY
      this.clientLeft = e.changedTouches['0'].clientX
      this.isShowTouch = true
    },
    /**
     * 删除自己跟帖评论或回复评论人
     * @date: 2020/8/20
     */
    async deleteSelfReplytoe () {
      let recipient = this.deleteRender.recipient
      let index = this.deleteRender.index
      this.isShowTouch = false
      if (recipient.objectId !== this.userInfo.objectId &&
        this.postsDetail.author.objectId !== this.userInfo.objectId) { return }
      await this.subDelEnter(index)
    },
    /**
     * 删除跟帖评论
     * @date: 2020/8/20
     */
    async subDelEnter (index) {
      if (this.enterLoading) {
        return this.$tkGlobal.toast.add('您点的太快了')
      }
      if (!this.postsDetail.reviewsPostsList[index]) {
        return this.$tkGlobal.toast.add('未找到该评论信息')
      }
      this.enterLoading = true
      this.postsDetail.reviewsPostsList.splice(index, 1)
      await this.$tkParse.put(`/classes/InformationPosts/${this.postsDetail.objectId}`, {
        reviewsPostsList: this.postsDetail.reviewsPostsList
      }).catch(e => {
        this.enterLoading = false
        throw this.$tkGlobal.toast.add('删除跟帖评论失败')
      })
      // 更新页面
      this.$tkGlobal.toast.add('跟帖评论删除成功')
      await this.$tkHelper.sleep(500)
      this.enterLoading = false
      this.$forceUpdate()
    },
    /**
    * 复制评论
    * @date: 2020/8/21
    */
    copyReviews () {
      copy(this.deleteRender.data.reviewerContent).then(s => {
        this.isShowTouch = false
        this.$tkGlobal.toast.add('复制评论成功')
      }).catch(e => {
        this.$tkGlobal.toast.add('复制评论失败')
      })
    },
    /**
     * 删除回复信息
     * @date: 2020/9/15
     */
    async deleteReplyToe (replytoe, index, idIndex) {
      if (this.isDelReplytoe) {
        return this.$tkGlobal.toast.add('您点的太快了')
      }
      if (replytoe.objectId !== this.userInfo.objectId) {
        return this.$tkGlobal.toast.add('您没有该权限')
      }
      this.isDelReplytoe = true
      await this.$tkHelper.sleep(300)
      this.postsDetail.reviewsPostsList[index].whatToReply.splice(idIndex, 1)
      await this.$tkParse.put(`/classes/InformationPosts/${this.postsDetail.objectId}`, {
        reviewsPostsList: this.postsDetail.reviewsPostsList
      }).catch(e => {
        this.isDelReplytoe = false
        throw this.$tkGlobal.toast.add('删除回复信息失败')
      })
      // 更新页面
      this.$tkGlobal.toast.add('回复信息删除成功')
      await this.$tkHelper.sleep(500)
      this.isDelReplytoe = false
      this.$forceUpdate()
    },
    /**
     * 回复他人评论
     * @date: 2020/3/26
     */
    enterReplytoe (recipient, data, index) {
      // recipient 接收人 replytoe 回复人
      if (!recipient) { return this.$tkGlobal.toast.add('未找到您要回复用户的信息') }
      if (recipient.objectId === this.userInfo.objectId) { return this.$tkGlobal.toast.add('您不能回复自己哦') }
      this.isCommentsShow = true
      this.reviewsData = data // 获取评论的信息
      this.recipient = recipient // 获取接收人信息
      this.reviewsIndex = index
      this.placeholder = `回复${recipient.name}：` // 改变placeholder
      this.$forceUpdate()
    },
    // 给帖子发送评论或回复其他人的评论
    async enterComments () {
      // 判断是否为评论
      if (!this.postsDetail) { return this.$tkGlobal.toast.add('未找到您要评论的帖子') }
      let isPosts = await this.judgeId(this.postsDetail.objectId, 'InformationPosts')
      if (!isPosts) {
        this.$tkGlobal.toast.add('该帖已被删除')
        return
      }
      if (!this.comments) { return this.$tkGlobal.toast.add('评论内容不能为空') }
      // 获取最新的帖子评论信息
      let postsDetail = await this.$tkParse.getList(`/classes/InformationPosts`, { params: { limit: 1, include: 'author', where: { objectId: this.$route.query.id } } })
      this.postsDetail = postsDetail[0]
      if (this.recipient && this.reviewsData) { // 回复信息
        this.reviewsData = this.postsDetail.reviewsPostsList[this.reviewsIndex]
        // 获取服务器时间 即现在时间
        let nowTime = await this.$tkParse.getData(`https://api.mokekeji.com/time`)
        if (!this.reviewsData.whatToReply) { this.reviewsData.whatToReply = [] }
        let obj = {
          date: nowTime,
          content: this.comments,
          replytoe: this.userInfo,
          recipient: this.recipient
        }
        this.reviewsData.whatToReply.push(obj)
        // 更新页面数据显示
        this.postsDetail.reviewsPostsList[this.reviewsIndex] = this.reviewsData
        // 修改评论信息
        await this.$tkParse.put(`/classes/InformationPosts/${this.postsDetail.objectId}`,
          {
            reviewsPostsList: this.postsDetail.reviewsPostsList
          }
        )
        this.$tkGlobal.toast.add('回复成功')
        this.recipient = null
        this.reviewsData = null
        this.placeholder = '评论'
      } else { // 评论信息
        if (!this.postsDetail.commentUser) { this.postsDetail.commentUser = [] }
        if (!this.postsDetail.reviewsPostsList) { this.postsDetail.reviewsPostsList = [] }
        this.postsDetail.reviewsPostsList.push({
          reviewer: this.userInfo,
          reviewerContent: this.comments
        })
        if (!this.postsDetail.commentUser.length ||
          (this.postsDetail.commentUser.length && !this.postsDetail.commentUser.includes(this.userInfo.objectId))) {
          this.postsDetail.commentUser.push(this.userInfo.objectId)
        }
        await this.$tkParse.put(`/classes/InformationPosts/${this.postsDetail.objectId}`,
          {
            commentUser: this.postsDetail.commentUser,
            reviewsPostsList: this.postsDetail.reviewsPostsList
          }
        )
        this.$tkGlobal.toast.add('评论成功')
      }
      this.comments = ''
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped lang="scss">
/*帖子详情背景*/
.posts-detail {
  background-color: #fff;
  /*帖子关注样式*/
  .post-card-watch {
    width: 55px;
    height: 25px;
    font-size: 13px;
    text-align: center;
    line-height: 25px;
    background-color: rgba(245, 245, 245, 1);
    border-radius: 13px;
  }
}
/*删除评论弹框样式*/
.posts-detail-delete {
  position: absolute;
  background: #fff;
  width: 75px;
  height: 110px;
  color: #000;
  padding-left: 15px;
  border-radius: 2px;
  box-shadow: 0 3px 6px rgba(0,0,0,0.16);
}
/*帖子图片样式*/
.welfare-link-image {
  overflow: hidden;
  width: 100%;
}
/*点赞及评论样式*/
.posts-card-footer {
  min-height: 20px;
  background: rgba(247,247,247,1);
  border: 1px solid #f5f5f5;
  border-radius: 5px;
  .posts-card-footer-top {
    color: rgba(91, 108, 143, 1);
    font-size: 15px;
  }
  .posts-card-footer-bottom-tips {
    color: rgba(91, 108, 143, 1);
  }
  .posts-card-footer-bottom-color {
    font-size: 15px;
    color: rgba(91, 108, 143, 1);
    word-break: break-all;white-space: normal;
  }
  .delete-replytoe {
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 19px;
    border-radius: 50%;
  }
}
/*输入框样式*/
.comments {
  position: relative;
  border-top: 1px solid #f5f5f5;
  background-color: rgba(241,241,241,1);
  padding: 6px 12px 7px 12px;
  min-height: 49px;
  .comments-bg {
    background: #fff;
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .comments-area {
    height: 100%;
    width: 100%;
    min-width: 0;
    overflow-y: auto;
    resize: none;
  }
  .comments-area::placeholder {
    font-size: 14px;
    color: rgba(153, 153, 153, 1);
  }
  .comments-btn {
    padding-left: 10px;
    .comments-btn-enter {
      border-radius: 5px;
      border: 1px solid #dad8d8;
      height: 32px;
      margin: 0;
    }
    ::v-deep .tkui-button.disabled {
      background: #f8f6f8 !important;
      opacity: 1 !important;
      color: #d6d3d6 !important;
    }
  }
}
</style>
